import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DotDotDot',
  setup(__props, { expose: __expose }) {
  __expose();

const dotCount = ref(0);

const timerRef = ref<number | null>(null);

const incDots = () => {
    dotCount.value = (dotCount.value + 1) % 4
}

onMounted(() => {
    timerRef.value = setInterval(incDots, 1000, undefined);
})

onUnmounted(() => {
    if(timerRef.value)
        clearInterval(timerRef.value);
})

const __returned__ = { dotCount, timerRef, incDots, onMounted, onUnmounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})